import styles from "./forgotPasswordForm.module.css";
import React, { useState } from 'react';
function ForgotPasswordForm() {
    const [email, setEmail] = useState('');
    const [status, setStatus] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const res = await fetch('/api/auth/request-password-reset', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email }),
        });
        const data = await res.json();
        setStatus(data.message || "Sofern ein Account mit dieser E-Mail existiert, verschicken wir einen entsprechenden Link.");
    };

    return (
        <div className={styles.container}>
            <h1>Passwort vergessen?</h1>
            <p>Übermittle hier uns deine E-Mail und wir senden dir über diese einen Link zum zurücksenden deines Passwortes.</p>
            <div className={styles.formContainer}>
                <form className={styles.form} onSubmit={handleSubmit}>
                    {status ?
                        (
                            <p className={styles.status}>{status}</p>
                        ) :
                        (

                            <>
                                <input type="email" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} required />
                                <button className={styles.button} type="submit">Link anfordern</button>
                            </>


                        )
                    }
                </form>

            </div>
        </div>
    );
}
export default ForgotPasswordForm;